<template>
  <validation-provider :name="name" :rules="rules" v-slot="{ errors }">
    <div>
      <input type="text" v-model="dummy_text" class="d-none" />
      <div>
        <base-select
          :label="label"
          :is_required="is_required"
          :options="filtered_options"
          field="selected"
          :value="selected"
          @change-value="setValue"
          :disabled="disabled ? true : false"
          :is_invalid="errors && errors?.length ? true : false"
          :helper_text="helper_text ? helper_text : errors && errors?.length ? errors[0] : null"
          :id="id"
          :helper_text_style="helper_text ? '' : 'color:var(--color-47);'"
          :small="small"
          :multi_select="true"
        ></base-select>
      </div>
      <div
        v-if="inputfield && inputfield?.length"
        :class="[
          {
            'col-lg-6': !small,
          },
          {
            'col-lg-12': small,
          },
          {
            'col-md-6': !small,
          },
          {
            'col-md-12': small,
          },
          'col-sm-12',
          'multiselect-options-list',
        ]"
        :style="small ? 'margin-bottom:20px' : ''"
      >
        <div v-for="(each, index) in inputfield" :key="index" class="multiselect-option">
          <div class="cross-icon">
            <img
              src="@/assets/images/icons/cross-icon-light.svg"
              alt="cross-icon"
              @click.stop="removeEntity(index)"
              :class="{ 'pointer-events-none': disabled }"
            />
          </div>
          <div class="text">
            {{ each.text }}
          </div>
        </div>
      </div>
    </div>
  </validation-provider>
</template>

<script>
export default {
  emits: ['change-value', 'change'],
  props: [
    'name',
    'rules',
    'label',
    'is_required',
    'options',
    'field',
    'value',
    'disabled',
    'helper_text',
    'id',
    'small',
  ],
  data() {
    return {
      selected: null,
      inputfield: this.value || [],
      dummy_text: this.value && this.value?.length ? this.value?.map((e) => e.text).join() : null,
      filtered_options: this.options,
    }
  },
  methods: {
    setValue(val, field) {
      this[field] = val
    },
    removeEntity(index) {
      let temp = this.inputfield
      if (index >= 0) {
        temp.splice(index, 1)
      }
      this.inputfield = temp
    },
  },
  watch: {
    options(val) {
      this.filtered_options = val?.filter(
        (rec) => !this.inputfield || this.inputfield.findIndex((each) => each.value === rec.value) < 0
      )
      if (val?.length === 0) {
        this.inputfield = []
        this.dummy_text = null
        this.selected = null
      }
    },
    selected(val) {
      if (val) {
        const rec = this.options?.find((each) => each.value === val)
        if (
          rec &&
          (!this.inputfield ||
            (this.inputfield && this.inputfield.findIndex((each) => each.value === val) < 0))
        ) {
          this.inputfield.push(rec)
          setTimeout(() => {
            this.selected = null
          }, 10)
        }
      }
    },
    inputfield(val) {
      this.filtered_options = this.options.filter(
        (rec) => !val || val.findIndex((each) => each.value === rec.value) < 0
      )
      if (val) {
        this.dummy_text = val?.map((e) => e.text).join()
        this.$emit('change-value', this.inputfield, this.field)
        this.$emit('change')
      }
    },
    value(val) {
      if (JSON.stringify(val) !== JSON.stringify(this.inputfield)) this.inputfield = val
      if (val?.length === 0) this.dummy_text = null
    },
  },
  mounted() {
    this.filtered_options = this.options?.filter(
      (rec) => !this.inputfield || this.inputfield.findIndex((each) => each.value === rec.value) < 0
    )
  },
}
</script>

<style lang="scss" scoped>
.multiselect-options-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .multiselect-option {
    display: flex;
    align-items: center;
    margin: 10px 4px;
    background: var(--color-23);
    border-radius: 6px;
    padding: 0.6rem;

    .cross-icon {
      margin-inline-end: 0.5rem;
      cursor: pointer;
    }

    .text {
      font-weight: 600;
      font-size: 14px;
      color: var(--color-01);
    }
  }

  .pointer-events-none {
    pointer-events: none;
  }
}
</style>
